import React from 'react';
import type { ButtonProps } from '@atlaskit/button';
import CustomThemeButton, {
	type ThemeProps,
	type ThemeTokens,
} from '@atlaskit/button/custom-theme-button';
import { Flex, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

/**
 * A styled button with a gradient background, intended to be used as a product edition upgrade CTA button.
 */
export const CtaButton = (props: ButtonProps) => (
	<CustomThemeButton theme={ButtonTheme} {...props}>
		<Flex xcss={buttonTextStyles} alignItems="center" justifyContent="center">
			{props.children}
		</Flex>
	</CustomThemeButton>
);

const buttonTextStyles = xcss({
	font: 'font.body',
	fontWeight: '500',
	lineHeight: 'space.250',
});

const ButtonThemeCss = {
	display: 'inline-flex',
	alignItems: 'center',
	padding: `${token('space.075', '6px')} ${token('space.150', '12px')}`,

	border: 'none',
	borderRadius: `${token('space.050', '4px')}`,
	background: `linear-gradient(79deg,
        ${token('color.chart.purple.bolder.hovered', '#6E5DC6')} 33.05%,
        ${token('color.chart.blue.bolder.hovered', '#0C66E4')} 99.57%)`,
	color: token('color.text.inverse', '#FFFFFF'),
	textDecoration: 'none',

	'&:hover': {
		cursor: 'pointer',
		background: `linear-gradient(79deg,
            ${token('color.chart.purple.boldest', '#5E4DB2')} 33.05%,
            ${token('color.chart.blue.boldest', '#0055CC')} 99.57%)`,
	},

	'&:active': {
		cursor: 'pointer',
		background: `linear-gradient(79deg,
            ${token('color.chart.purple.boldest.hovered', '#352C63')} 33.05%,
            ${token('color.chart.blue.boldest.hovered', '#09326C')} 99.57%)`,
	},

	'& span': {
		display: 'inline-flex',
		margin: 0,
	},
};

const ButtonTheme = (currentTheme: (props: ThemeProps) => ThemeTokens, themeProps: ThemeProps) => {
	const theme = currentTheme(themeProps);

	return {
		...theme,
		buttonStyles: {
			...ButtonThemeCss,
		},
	};
};
